import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogService } from 'src/app/services/blogs/blog.service';

@Component({
    selector: 'app-single-post',
    templateUrl: './single-post.component.html',
    styleUrls: ['./single-post.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SinglePostComponent implements OnInit {
blogId: any;
blog: any;
backgroundImageUrl: string | any;
isLoading: boolean = true
  constructor(private currentRoute: ActivatedRoute, private blogService: BlogService) {
    this.blogId = this.currentRoute.snapshot.paramMap.get('id');
   }

  ngOnInit(): void {


    this.blogService.getSingleBlog(this.blogId).subscribe((res:any)=> {

      this.blog = res
      const backgroundImageUrls: string[] = res.cloudinaryUrls;
      this.backgroundImageUrl = backgroundImageUrls.length > 0 ? backgroundImageUrls[0] : '';
      this.isLoading = false
    })
  }

}
